import { useState, useEffect, useRef, useMemo } from "react";
import "../Assets/scss/hybridExam.scss";
import { BASE_URL } from "../env";
import axios from "axios";
import { developAxios } from "../axios.config";
import {
	Dialog,
	DialogTitle,
	DialogActions,
	Button,
	DialogContent,
	Fab,
	FormControlLabel,
	Switch,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { InputGroup, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import moment from "moment";
import Select from "react-select";

const CopyLinkDialog = (props) => {
	const { onClose, open, hybridExamId } = props;

	const handleCopyToClipboard = async (copyLink) => {
		try {
			await navigator.clipboard.writeText(copyLink);
		} catch (error) {
			console.error(error);
		}
	};

	const { examLink, liveTrackerLink } = useMemo(
		() => ({
			examLink: `https://cantileverlabs.com/hybrid-exam/${hybridExamId}`,
			liveTrackerLink: `https://main.dj590z7xxbw2r.amplifyapp.com/hybrid-exam-live/${hybridExamId}`,
		}),
		[hybridExamId]
	);

	return (
		<Dialog onClose={onClose} open={open} maxWidth="md" fullWidth={true}>
			<DialogTitle>Hybrid Exam Links and Id</DialogTitle>
			<DialogContent>
				<InputGroup className="mb-3">
					<Form.Control
						type="text"
						readOnly={true}
						value={examLink}
					/>
					<Fab
						aria-label="copy-to-clip"
						onClick={() => handleCopyToClipboard(examLink)}
					>
						<ContentCopy />
					</Fab>
				</InputGroup>
				<InputGroup className="mb-3">
					<Form.Control
						type="text"
						readOnly={true}
						value={liveTrackerLink}
					/>
					<Fab
						aria-label="copy-to-clip"
						onClick={() => handleCopyToClipboard(liveTrackerLink)}
					>
						<ContentCopy />
					</Fab>
				</InputGroup>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

const HybridExam = () => {
	const [quizData, setQuizData] = useState([]);
	const [codingData, setCodingData] = useState([]);
	const [courseData, setCourseData] = useState([]);
	const [quizOutOfScore, setQuizOutOfScore] = useState(0);
	const [codeOutOfScore, setCodeOutOfScore] = useState(0);
	const [hybridExamData, setHybridExamData] = useState(null);
	const [displayDialog, setDisplayDialog] = useState(false);
	const [data, setData] = useState({
		examName: "",
		examStart: "",
		examStartTime: "",
		examEnd: "",
		examEndTime: "",
		examTime: "",
		mainIns: "",
		quizIns: "",
		codingIns: "",
		quizId: undefined,
		codingId: undefined,
		courseId: undefined,
		typeOfExam: "",
		attempts: "1",
		displayResult: false,
	});
	const { examId } = useParams();

	const inputEvent = (event) => {
		const { name, value } = event.target;
		setData((prev) => ({ ...prev, [name]: value }));
	};

	const PostData = async () => {
		const postData = {
			code_outOfScore: codeOutOfScore,
			quiz_outOfScore: quizOutOfScore,
			nameoftheExam: data.examName,
			startdate: new Date(`${data.examStart} ${data.examStartTime}`),
			enddate: new Date(`${data.examEnd} ${data.examEndTime}`),
			instructionmain: data.mainIns.split("~;~"),
			QuizInstruction: data.quizIns.split("~;~"),
			CodeInstruction: data.codingIns.split("~;~"),
			exam_timer: data.examTime,
			Codeexam: data.codingId.value,
			Quizexam: data.quizId.value,
			courseId: data.courseId.value,
			typeOfExam: data.typeOfExam,
			attempts: data.attempts,
			displayResult: data.displayResult,
		};

		developAxios(localStorage.getItem("token"))
			.post(
				`/getallexams/${examId ? "update/" + examId : "create"}`,
				postData
			)
			.then(({ data }) => {
				setDisplayDialog(true);
				setHybridExamData(data.exam);
			})
			.catch((err) => console.error(err));
	};

	const submitEvent = async (e) => {
		e.preventDefault();

		await PostData();
	};

	useEffect(() => {
		if (!examId || !codingData || !quizData || !courseData) return;
		developAxios(localStorage.getItem("token"))
			.get("/getparticularexam/" + examId)
			.then(({ data: { exam: examData } }) => {
				const {
					attempts,
					nameoftheExam,
					instructionmain,
					QuizInstruction,
					CodeInstruction,
					typeOfExam,
					startdate,
					enddate,
					courseId,
					displayResult,
				} = examData;

				let codid = codingData.filter(
					(val) => val.value === examData.Codeexam
				)[0];
				let quid = quizData.filter(
					(val) => val.value === examData.Quizexam
				)[0];
				let coId = courseData.filter(
					(val) => val.value === courseId
				)[0];
				setQuizOutOfScore(examData.quiz_outOfScore);
				setCodeOutOfScore(examData.code_outOfScore);
				setData({
					attempts,
					examName: nameoftheExam,
					mainIns: instructionmain.join("~,~"),
					quizIns: QuizInstruction.join("~,~"),
					codingIns: CodeInstruction.join("~,~"),
					examTime: examData.exam_timer,
					typeOfExam,
					examStart: moment(startdate).format("YYYY-MM-DD"),
					examStartTime: moment(startdate).format("HH:mm"),
					examEnd: moment(enddate).format("YYYY-MM-DD"),
					examEndTime: moment(enddate).format("HH:mm"),
					quizId: quid,
					codingId: codid,
					courseId: coId,
					displayResult,
				});
			})
			.catch((err) => console.log(err));
	}, [examId, codingData, quizData, courseData]);

	useEffect(() => {
		const QuizData = async () => {
			try {
				const res = await axios({
					method: "get",
					url: `${BASE_URL}/getQuizAllEXam`,
				});
				setQuizData(
					res.data.data.map((val) => ({
						value: val._id,
						label: val.examName,
						outOfScore: val.outOfScore,
					}))
				);
			} catch (error) {
				console.error(error);
			}
		};
		QuizData();
	}, []);

	useEffect(() => {
		const CodingData = async () => {
			try {
				const res = await axios({
					method: "get",
					url: `${BASE_URL}/getAllexam`,
				});
				setCodingData(
					res.data.data.map((val) => ({
						value: val._id,
						label: val.name,
						outOfScore: val.outOfScore,
					}))
				);
			} catch (error) {
				console.error(error);
			}
		};
		CodingData();
	}, []);

	useEffect(() => {
		const CourseData = async () => {
			try {
				const res = await axios({
					method: "get",
					url: `${BASE_URL}/getallCourse`,
					headers: {
						"Content-Type": "application/json",
						authorization:
							"Bearer " + localStorage.getItem("token"),
					},
				});
				setCourseData(
					res.data.courses.map((val) => ({
						value: val._id,
						label: val.name,
					}))
				);
			} catch (error) {
				console.error(error);
			}
		};
		CourseData();
	}, []);

	function closeDialog() {
		setDisplayDialog(false);
	}

	return (
		<>
			<CopyLinkDialog
				open={displayDialog}
				onClose={closeDialog}
				hybridExamId={hybridExamData ? hybridExamData._id : ""}
			/>
			<div id="hybridExam">
				<div className="container-fluid p-0">
					<div className="row gx-0">
						<div className="col-md-6 mb-0 hybridExamRight">
							<p>
								<span>Exam Name</span>
								{data.examName}
							</p>
							<p>
								<span>Exam Start</span>
								{`${data.examStart} ${data.examStartTime}`}
							</p>
							<p>
								<span>Exam End</span>
								{`${data.examEnd} ${data.examEndTime}`}
							</p>
							<p>
								<span>Exam Time</span>
								{data.examTime}
							</p>
							<p>
								<span>Main Instruction</span>
								{data.mainIns}
							</p>
							<p>
								<span>Quiz Instruction</span>
								{data.quizIns}
							</p>
							<p>
								<span>Coding Instruction</span>
								{data.codingIns}
							</p>
							<p>
								<span>quiz Id</span>
								{data.quizId?.value || ""}
							</p>
							<p>
								<span>coding Id</span>
								{data.codingId?.value || ""}
							</p>
							<p>
								<span>course Id</span>
								{data.courseId?.value || ""}
							</p>
							<p>
								<span>Type of exam</span>
								{data.typeOfExam}
							</p>
							<p>
								<span>Number of attempts</span>
								{data.attempts}
							</p>
							<p>
								<span>Display Result</span>
								{data.displayResult
									? "Displayed"
									: "Not displayed"}
							</p>
						</div>
						<div className="col-md-6 mb-0 hybridExamLeft">
							<form onSubmit={submitEvent}>
								<div className="label">Exam Name</div>
								<input
									type="text"
									className="inputField"
									name="examName"
									value={data.examName}
									onChange={inputEvent}
									placeholder="Enter name of the exam"
								/>
								<div className="label">Exam Start</div>
								<input
									type="date"
									className="inputField"
									name="examStart"
									value={data.examStart}
									onChange={inputEvent}
								/>
								<input
									type="time"
									className="inputField"
									name="examStartTime"
									value={data.examStartTime}
									onChange={inputEvent}
								/>
								<div className="label">Exam End</div>
								<input
									type="date"
									className="inputField"
									name="examEnd"
									value={data.examEnd}
									onChange={inputEvent}
								/>
								<input
									type="time"
									className="inputField"
									name="examEndTime"
									value={data.examEndTime}
									onChange={inputEvent}
								/>
								<div className="label">Exam Time</div>
								<input
									type="number"
									className="inputField"
									name="examTime"
									value={data.examTime}
									onChange={inputEvent}
									placeholder="Enter name of the exam"
								/>
								<div className="label">Main Instructions</div>
								<input
									type="text"
									className="inputField"
									name="mainIns"
									value={data.mainIns}
									onChange={inputEvent}
									placeholder="Enter name of the exam"
								/>
								<div className="label">Quiz Instructions</div>
								<input
									type="text"
									className="inputField"
									name="quizIns"
									value={data.quizIns}
									onChange={inputEvent}
									placeholder="Enter name of the exam"
								/>
								<div className="label">Coding Instructions</div>
								<input
									type="text"
									className="inputField"
									name="codingIns"
									value={data.codingIns}
									onChange={inputEvent}
									placeholder="Enter name of the exam"
								/>
								<div className="label">Quiz Id</div>
								<Select
									options={quizData}
									onChange={(val) =>
										setData((prev) => ({
											...prev,
											quizId: val,
										}))
									}
									value={data.quizId}
									isLoading={quizData.length === 0}
								/>
								<div className="label">Coding Id</div>
								<Select
									options={codingData}
									onChange={(val) =>
										setData((prev) => ({
											...prev,
											codingId: val,
										}))
									}
									value={data.codingId}
									isLoading={codingData.length === 0}
								/>
								<div className="label">Course ID</div>
								<Select
									options={courseData}
									onChange={(val) =>
										setData((prev) => ({
											...prev,
											courseId: val,
										}))
									}
									value={data.courseId}
									isLoading={courseData.length === 0}
								/>
								<div className="label">
									{" "}
									Type of Exam (assignment/test)
								</div>
								<input
									type="text"
									className="inputField"
									name="typeOfExam"
									value={data.typeOfExam}
									onChange={inputEvent}
									placeholder="Enter type of the exam"
								/>
								<br />
								<div className="label">Number of attempts</div>
								<input
									type="number"
									className="inputField"
									name="attempts"
									value={data.attempts}
									onChange={inputEvent}
									placeholder="Enter the number of attempts"
								/>
								<br />
								<FormControlLabel
									control={
										<Switch
											value={data.displayResult}
											onChange={() =>
												setData((prev) => ({
													...prev,
													displayResult:
														!prev.displayResult,
												}))
											}
										/>
									}
									label="Display Result"
								/>
								<br />

								<button type="submit" className="submitBtn">
									{examId ? "Update" : "Submit"}
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default HybridExam;
